import { baseApi } from 'api/api-base';
import { API_ROUTES } from 'constants/api-routes';

import { GetElectricityCostTransactions, GetFiatTransactions } from 'types/api/api-transactions.types';
import { ElectricityCostTransaction, FiatTransaction } from 'types/transactions.types';

export const transactionsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getFiatTransactions: builder.query<GetFiatTransactions.ResponseType, GetFiatTransactions.RequestType>({
      query: () => ({
        url: `${API_ROUTES.GET_FIAT_TRANSACTIONS}`,
      }),
      providesTags: ['Account'],
      extraOptions: {},
      transformResponse: (
        response: GetFiatTransactions.RawApiResponse | FiatTransaction[],
      ): GetFiatTransactions.ResponseType => {
        if ('success' in response && response.success && 'data' in response) {
          return response.data;
        }
        return response as FiatTransaction[];
      },
    }),

    getElectricityCostTransactions: builder.query<
      GetElectricityCostTransactions.ResponseType,
      GetElectricityCostTransactions.RequestType
    >({
      query: () => ({
        url: `${API_ROUTES.GET_ELECTRICITY_COST_TRANSACTIONS}`,
      }),
      providesTags: ['Account'],
      extraOptions: {},
      transformResponse: (
        response: GetElectricityCostTransactions.RawApiResponse | ElectricityCostTransaction[],
      ): GetElectricityCostTransactions.ResponseType => {
        if ('success' in response && response.success && 'data' in response) {
          return response.data;
        }
        return response as ElectricityCostTransaction[];
      },
    }),
  }),
});

export const { useGetFiatTransactionsQuery, useGetElectricityCostTransactionsQuery } = transactionsApi;
